import "./SummaryCard.css";

import MastercardIcon from "assets/images/logos/mastercard_icon.svg";
import RupeeIcon from "assets/images/logos/rupee_icon.svg";
import UpiIcon from "assets/images/logos/upi_icon.svg";
import SodexoIcon from "assets/images/sodexo.png";
import { getStoreCurrencySymbol } from "../../../../../../../../utils/currency";

const SummaryCard = ({ data }) => {
  const paymentMethods = localStorage.getItem("paymentMethods");
  const hasSodexo = paymentMethods?.includes("SODEXO");

  const summaryData = [
    {
      icon: UpiIcon,
      alt: "upi icon",
      title: "UPI",
      amount: data?.upiOrdersValue || "0",
      orders: data?.upiOrders || "0",
    },
    {
      icon: MastercardIcon,
      alt: "mastercard icon",
      title: "Card",
      amount: data?.cardOrdersValue || "0",
      orders: data?.cardOrders || "0",
    },
    ...(hasSodexo
      ? [
          {
            icon: SodexoIcon,
            alt: "sodexo icon",
            title: "Sodexo",
            amount: data?.sodexoOrdersValue || "0",
            orders: data?.sodexoOrders || "0",
          },
        ]
      : []),
  ];

  return (
    <div className="summary-box-wrapper">
      {summaryData?.map((data, index) => (
        <div className="summary-box" key={index} style={{ "--bg-image": `url(${data?.icon})` }}>
          <div className="summary-box-title-box">
            <div className="summary-box-icon-wrapper">
              <img src={data?.icon} alt={data?.alt} className="summary-box-icon" />
            </div>
            <p className="summary-box-title">{data?.title}</p>
          </div>
          <div className="summary-box-amount-box">
            <p className="summary-box-amount">{getStoreCurrencySymbol()}{data?.amount}</p>
          </div>
          <div className="summary-box-orders-box">
            <p className="summary-box-orders">{data?.orders} Orders</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCard;
